const Footer = () => (
    <footer className="footer">
        <p className="footer-text">&copy; 2023 <a href="https://github.com/cmdvmd" target="_blank"
                                                  rel="noopener noreferrer">cmdvmd</a>, <a
            href="https://sites.google.com/view/athens-science-olympiad/home" target="_blank" rel="noopener noreferrer">Troy
            Athens Science Olympiad</a></p>
        <div className="footer-actions">
            <p className="footer-text"><a href="mailto:vcmd43@gmail.com">Report a Problem</a></p>
        </div>
    </footer>
);

export default Footer;
